import type { VariantProps } from "@gluestack-ui/utils/nativewind-utils";
import React from "react";
import { hstackStyle, spaces } from "./styles";

type IHStackProps = React.ComponentPropsWithoutRef<"div"> &
  VariantProps<typeof hstackStyle>;

const HStack = React.forwardRef<React.ComponentRef<"div">, IHStackProps>(
  function HStack({ className, space, reversed, ...props }, ref) {
    return (
      <div
        className={hstackStyle({
          space: space as keyof typeof spaces,
          reversed: reversed as boolean,
          class: className,
        })}
        {...props}
        ref={ref}
      />
    );
  }
);

HStack.displayName = "HStack";

export { HStack };
